import CarouselProvider, { useCarouselContext } from './CarouselProvider';

export default CarouselProvider;

export { useCarouselContext };
